import React from "react";
import classes from "./LessonDetails.module.css";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import ModalSkeletonClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import { Button } from "../../../../../stories/Button/Button";
import {
  CalendarIconGray,
  CancelIconBlack,
  ClockIconGray,
  coachDemoImg,
  LocationIconGray,
  ChatBlackIcon,
  FlagIconBlack,
} from "../../../../../constant/imagePath";
import moment from "moment";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { ReactSVG } from "react-svg";

const ScheduleLessonDetails = ({ show, setShow, data }) => {
  console.log(data);
  return (
    <>
      <style>{`
      .modal .modal-dialog {
        width: 328px;
      }
            @media screen and (max-width: 425px) {
          .modal .modal-dialog {
            width: 95% !important;
            margin: 0px auto;

          }
          }
          .${ModalSkeletonClasses.header}{
            margin:24px;
          }
          .modal-body{
            padding:0 24px;
          }

    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={{ padding: "0px", margin: "0px" }}
        width={"570px"}
        header={
          <h4
            className={classes.heading}
            style={{
              ...Fonts.h4,
              fontSize: "20px",
              lineHeight: "28px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Lesson details
          </h4>
        }
        footer={
          <>
            {data?.status === "pending" && (
              <div className={classes.footerBtns}>
                <Button
                  icon={CancelIconBlack}
                  label={""}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "48px",
                    height: "48px",
                    marginRight: "8px",
                    backgroundColor: Colors.white,
                  }}
                />
                <Button
                  label={"Accept"}
                  primary={true}
                  size={"Large"}
                  customStyle={{
                    width: "224px",
                    height: "48px",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                />
              </div>
            )}

            {data?.status === "evaluate" && (
              <div className={classes.footerBtns}>
                <Button
                  icon={FlagIconBlack}
                  label={""}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "48px",
                    height: "48px",
                    marginRight: "8px",
                    backgroundColor: Colors.white,
                  }}
                />
                <Button
                  label={"Evaluate"}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "224px",
                    height: "48px",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                />
              </div>
            )}

            {data?.status === "cancel" && (
              <div className={classes.footerBtns}>
                <Button
                  icon={ChatBlackIcon}
                  label={""}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "48px",
                    height: "48px",
                    marginRight: "8px",
                    backgroundColor: Colors.white,
                  }}
                />
                <Button
                  label={"Cancel the lesson"}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "224px",
                    height: "48px",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                />
              </div>
            )}
          </>
        }
      >
        <div className={classes.modalContent}>
          <div className={[classes.middleSectionTitleDiv]}>
            <div className={[classes.imgDiv]}>
              <img src={data?.user?.profile} alt="..." />
            </div>
            <div className={[classes.titleContent]}>
              <h6 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h6 }}>
                {`${data?.type} ${data?.title}`}
              </h6>
            </div>
          </div>
          <div className={[classes.detailDiv]}>
            <div
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              className={classes.aCenter}
            >
              <ReactSVG
                src={CalendarIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                {data?.eventDate}
              </span>
            </div>
            <div
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              className={classes.aCenter}
            >
              <ReactSVG
                src={ClockIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                {data?.start}
                {"-"}
                {data?.end}
              </span>
            </div>
            <div
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              className={classes.aCenter}
            >
              <ReactSVG
                src={LocationIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
                className={[classes.locationSpan]}
              >
                income {data?.location}
              </span>
            </div>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

ScheduleLessonDetails.propTypes = {
  data: PropTypes.object,
};

ScheduleLessonDetails.defaultProps = {
  data: {
    start: moment(moment().add(-3, "hours").format())
      .add(0, "days")
      .format("LT"),
    end: moment(moment().add(3, "hours").format()).add(0, "days").format("LT"),
    type: "1-on-1",
    id: 1,
    title: "Tennis Lesson with Jenny",
    eventDate: moment().add(0, "days").format("MMM DD, YYYY"),
    location: "Green Tennis Court",
    // status: "pending,evaluate,cancel",
    status: "evaluate",
    user: {
      profile: coachDemoImg,
    },
  },
};

export default ScheduleLessonDetails;
